<template>
  <section class="bg-dark py-5 text-light footer-widget" :style="`background: ${paramMapAll['THEME_APP_FOOTER_PRIMARY_COLOR']} !important;color: ${paramMapAll['THEME_APP_FOOTER_PRIMARY_TEXT_COLOR']} !important`">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-xl-3 text-center text-md-left">
          <div class="mt-4">
            <a class="d-block" href="/">
              <img
                alt=""
                class="ls-is-cached lazyloaded"
                height="100"
                :src="getLogo2()"
              />
            </a>
            <div class="my-3">
              <br />
            </div>
            <div class="d-inline-block d-md-block mb-4">
              <div class="form-inline">
                <div class="form-group mb-0">
                  <input
                    :placeholder="$t('您的电子邮件地址')"
                    class="form-control"
                    name="email"
                    required=""
                    type="email"
                  />
                </div>
                <button class="btn btn-primary" type="submit">
                  {{ $t("订阅") }}
                </button>
              </div>
            </div>
            <div class="w-300px mw-100 mx-auto mx-md-0">
              <div
                class="d-inline-block mr-3 ml-0"
                href="javascript:void(0)"
                target="_blank"
                v-if="paramMapAll['ANDROID_DOWNLOAD_URL']"
                @click="toLink(paramMapAll['ANDROID_DOWNLOAD_URL'])"
              >
                <img class="mx-100 h-40px" src="/static/assets/img/play.png" />
              </div>
              <div class="d-inline-block" target="_blank"
                   v-if="paramMapAll['IOS_DOWNLOAD_URL']"
                   @click="toLink(paramMapAll['IOS_DOWNLOAD_URL'])">
                <img class="mx-100 h-40px" src="/static/assets/img/app.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 ml-xl-auto col-md-4 mr-0">
          <div class="text-center text-md-left mt-4">
            <h4
              class="fs-13 text-uppercase fw-600 border-bottom border-gray-900 pb-2 mb-4"
            >
              {{ $t("联系方式") }}
            </h4>
            <ul class="list-unstyled">
              <li v-if="paramMapAll['SITE_CUSTOMER_ADDRESS']" class="mb-2">
                <span class="d-block opacity-30">{{ $t("地址") }}:</span>
                <span class="d-block opacity-70" v-html="paramMapAll['SITE_CUSTOMER_ADDRESS']"></span>
              </li>
              <li v-if="paramMapAll['SITE_CUSTOMER_PHONE']" class="mb-2">
                <span class="d-block opacity-30">{{ $t("电话号码") }}:</span>
                <span class="d-block opacity-70">{{
                  paramMapAll["SITE_CUSTOMER_PHONE"]
                }}</span>
              </li>
              <li v-if="paramMapAll['SITE_URL']" class="mb-2">
                <span class="d-block opacity-30">{{ $t("官网") }}:</span>
                <span class="d-block opacity-70" @click="toLink(paramMapAll['SITE_URL'])">{{
                  paramMapAll["SITE_URL"]
                }}</span>
              </li>
              <li v-if="paramMapAll['SITE_CUSTOMER_EMAIL']" class="mb-2">
                <span class="d-block opacity-30">Email:</span>
                <span class="d-block opacity-70">
                  <div
                    :href="`mailto:${paramMapAll['SITE_CUSTOMER_EMAIL']}`"
                    class="text-reset"
                  >
                    {{ paramMapAll["SITE_CUSTOMER_EMAIL"] }}
                  </div>
                </span>
              </li>
              <li v-if="paramMapAll['SITE_TAX_CODE']" class="mb-2">
                <span class="d-block opacity-30">{{ $t("纳税码") }}:</span>
                <span class="d-block opacity-70">
                  <div
                    class="text-reset"
                  >
                    {{ paramMapAll["SITE_TAX_CODE"] }}
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-2">
          <div class="text-center text-md-left mt-4">
            <h4
              class="fs-13 text-uppercase fw-600 border-bottom border-gray-900 pb-2 mb-4"
            >
              {{ $t("快速链接") }}
            </h4>
            <ul class="list-unstyled">
              <li
                v-for="poster in posterBottoms"
                :key="poster.id"
                class="mb-2 opacity-50 hov-opacity-100 text-reset"
                @click="jump(poster.url || `/terms?code=${poster.code}`)"
              >
                <!--                <a-->
                <!--                    class="opacity-50 hov-opacity-100 text-reset"-->
                <!--                    href="seller-policy"-->
                <!--                >-->
                {{ $t(poster.title) }}
                <!--                </a>-->
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-4 col-lg-2">
          <div class="text-center text-md-left mt-4">
            <h4
              class="fs-13 text-uppercase fw-600 border-bottom border-gray-900 pb-2 mb-4"
            >
              {{ $t("我的账户") }}
            </h4>
            <ul class="list-unstyled">
              <li v-if="!isLogin()" class="mb-2">
                <div
                  class="opacity-50 hov-opacity-100 text-reset"
                  @click="goto('/login')"
                >
                  {{ $t("登录") }}
                </div>
              </li>
              <li v-else class="mb-2">
                <div
                  class="opacity-50 hov-opacity-100 text-reset"
                  href="javascript:void(0)"
                  @click="logout"
                >
                  {{ $t("登出") }}
                </div>
              </li>
              <li class="mb-2">
                <div
                  class="opacity-50 hov-opacity-100 text-reset"
                  href="javascript:void(0)"
                  @click="goto('/user/purchase_history')"
                >
                  {{ $t("购买历史") }}
                </div>
              </li>
              <li class="mb-2">
                <div
                  class="opacity-50 hov-opacity-100 text-reset"
                  href="javascript:void(0)"
                  @click="goto('/user/wishlists')"
                >
                  {{ $t("愿望清单") }}
                </div>
              </li>
            </ul>
          </div>
          <div v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',登录页_注册店铺,')" class="text-center text-md-left mt-4">
            <h4
              class="fs-13 text-uppercase fw-600 border-bottom border-gray-900 pb-2 mb-4"
            >
              {{ $t("成为商家") }}
            </h4>
            <div
              class="btn btn-primary btn-sm shadow-md"
              href="javascript:void(0)"
              @click="goto('/shops/create')"
            >
              {{ $t("现在申请") }}
            </div>
          </div>
        </div>
        <div v-if="posterBottoms2 && posterBottoms2.length" class="col-lg-2 col-md-2">
          <div class="text-center text-md-left mt-4">
            <h4
                class="fs-13 text-uppercase fw-600 border-bottom border-gray-900 pb-2 mb-3"
            >
              {{ $t("系统安全") }}
            </h4>
            <ul class="list-unstyled">
              <li
                  v-for="poster in posterBottoms2"
                  :key="poster.id"
                  class="mb-2 opacity-50 hov-opacity-100 text-reset"
                  @click="jump(poster.url || `/terms?code=${poster.code}`)"
              >
                <!--                <a-->
                <!--                    class="opacity-50 hov-opacity-100 text-reset"-->
                <!--                    href="seller-policy"-->
                <!--                >-->
                {{ $t(poster.title) }}
                <!--                </a>-->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    posterBottoms: {},
    posterBottoms2: {},
  },
  created() {
    this.loadService();
  },
  methods: {
    isLogin() {
      return this.userInfo && this.userInfo.id;
    },
    loadService() {
      const serviceScript = this.paramMapAll["SERVICE_SCRIPT"];
      if (serviceScript) {
        let elscript = document.createElement("script");
        elscript.text = serviceScript;
        elscript.setAttribute("type", "text/javascript");
        document.body.appendChild(elscript);
      }
    }
  }
};
</script>
